export enum IProvider {
    YouTube = "youtube",
    Vimeo = "vimeo",
    Prezi = "prezi"
}

export interface IEmbedData {
    href: string,
    startHour?: number,
    startMinute?: number,
    startSecond?: number,
    endHour?: number,
    endMinute?: number,
    endSecond?: number,
    provider?: IProvider
    color: string,
}